<template>
    <div class="p-5">
        <div class="col-md-8 mx-auto py-0 my-0" v-if="fields.length > 0" v-for="(item,index) in properties"
             :key="item.label" :data-name="item.label">
            <component
                    :key="item.name"
                    :is="item.name === 'transformable_price' ? 'forRent' :item.component "
                    item-value="key"
                    item-text="lable"
                    :items="item.items"
                    :value="item.value"
                    :hint="item.hint"
                    @keypress="allowOnlyNumbers($event,item.name,item.type)"
                    :max="item.counter"
                    :maxLength="item.max"
                    rows="13"
                    :min="item.min"
                    :label="item.label"
                    oninput="if(Number(this.value) > Number(this.max) && this.type === 'number') this.value = this.max"
                    outlined
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    small-chips
                    :required="isRequire(item.required)"
                    :rules="item.rules"
                    :append-outer-icon="item.icons[2].icon"
                    :prepend-inner-icon="item.icons[0].icon"
                    @click:prepend-inner="item.icons[0].click"
                    @click:append-outer="item.icons[2].click"
                    :append-icon="item.icons[1].icon"
                    @click:append="item.icons[1].click"
                    @change="reload(item.autoReload,$event,item.name,item.type)"
                    :type="item.type"
                    :loading="loading"
                    :error-messages="item.errorMessage"
                    :name="item.name"
                    :placeholder="item.placeholder"
                    :multiple="item.name === 'colored_parts' "
                    dense>
            </component>
        </div>
    </div>
</template>

<script>
import {Bus} from "../../../../main";
import {VAutocomplete, VSelect, VSwitch, VTextarea, VTextField} from "vuetify/lib/components";

export default {
    name: "other_attrs",
    props: {
        param: {
            type: Object,
            require: true
        },
        fields: {
            default: () => {
                return []
            }
        },
        multi: {
            default: false,
        },
        current: {
            default: ''
        },
        multiAdsCat: {
            default: false,
        },
        editField: {
            type: Object,
            default: () => {
                return {}
            }
        },
        auto_change: {
            default: false,
            require: true
        },
    },
    data() {
        return {
            properties: [],
            auto: [],
            Ads: [],
            extra: [],
            city: '',
            productMessage: '',
            defaultTitle: false,
            getText: false,
            suggestText: false,
            expireTime: '',
            defaultDesc: false,
            auto_changes: this.auto_change,
            loading: false,
            iconIndex: 0,
            inputs: {
                "radio": VSelect,
                "string": VTextField,
                "TextFieldWidget": VTextField,
                "number": VTextField,
                "hierarchy_widget": VSelect,
                "SingleSelectHierarchyWidget": VSelect,
                "select": VAutocomplete,
                "textarea": VTextarea,
                "boolean": VSwitch,
                "array": VAutocomplete,
                "object": VAutocomplete,
                "checkboxes": VAutocomplete
            },
            icons: [
                'mdi-emoticon',
                'mdi-emoticon-angry',
                'mdi-emoticon-excited',
            ],
            parameters: this.param,
            timer: null,
            queryString: new URLSearchParams(),
        };
    },
    methods: {
        validate() {
            if (this.current === '') {
                this.$modal.error('خطا!', 'لطفا دسته موردنظرتان را انتخاب کنید.');
                return false;
            }

            let validate = true;

            this.properties.filter((x) => x.required === true).forEach((x) => {
                if (this.parameters[x.name]) {
                    validate = validate && true;
                } else {
                    x.errorMessage = 'واردکردن فیلد ' + ' «' + x.label + '» ' + 'الزامی است.'
                    validate = false;
                }
            })

            return validate;
        },
        getProperty(key) {
            const name = key.name;
            const min = key.min
            const max = key.max;
            const help = key.placeholder;
            const requireField = key.required;
            const placeholder = key.placeholder;
            const autoReload = key.auto_refresh;
            const has_field = key.fields
            let items = [];
            let type = key.field_type !== null ? key.field_type : (key.type !== 'integer' ? key.type : "number");
            let title = key.title;
            let itemValue = key.enum ?? [];
            let itemText = key.enumNames ?? itemValue;

            itemValue.forEach((item, index) => {
                items.push({
                    key: item,
                    lable: itemText[index]
                })
            })

            if (Object.keys(this.editField).length > 0) {
                if (this.timer != null)
                    clearTimeout(this.timer);

                this.timer = setTimeout(() => {
                    this.current = this.editField.category
                    this.editForm();
                    this.parameters = this.param
                    this.timer = null;
                }, 500);
            }

            return {
                component: this.inputs[type],
                label: title,
                counter: max ? max : null,
                hint: help ? help : null,
                items: items,
                name: name,
                min: min,
                value: "",
                required: requireField,
                placeholder: placeholder,
                has_fields: has_field,
                errorMessage: "",
                autoReload: autoReload,
                rules: [
                    (v) => {
                        if ((name === "title" || name === "description"))
                            return (this.required === true ? v < max : v.length <= max) || 'مقدار وارد شده بیش از حد مجاز است.حداکثر مقدار موردنیاز ' + max + ' است.';
                        else if (["boolean", "select", "string", "object", "number", "array", "hidden", "radio", "SingleSelectHierarchyWidget", "checkboxes", "hierarchy_widget"].indexOf(type) > -1)
                            return true;
                    },
                    (v) => {
                        if ((name === "title" || name === "description"))
                            return (this.required === true ? v > min : v.length >= min) || 'مقدار وارد شده کمتر از حد مجاز است.حداقل مقدار موردنیاز  ' + min + ' است.';
                        else if (["boolean", "select", "object", "string", "number", "array", "hidden", "number", "radio", "checkboxes", "hierarchy_widget"].indexOf(type) > -1)
                            return true;

                    },
                ],
                icons: [
                    {
                        icon: 'mdi-emoticon' ? title === 'عنوان آگهی' || title === 'توضیحات آگهی' ? this.icon : 'fas fa-pencil-alt' : this.icon,
                        click: () => {
                            if (title === 'عنوان آگهی')
                                this.emoji = true;
                            else if (title === "توضیحات آگهی")
                                this.emojidesc = true
                            else return false;
                        }
                    },
                    {
                        icon: 'mdi-emoticon' ? title === 'عنوان آگهی' || title === 'توضیحات آگهی' ? 'fa fa-edit' : '' : 'fa fa-edit',
                        click: () => {
                            if (title === 'عنوان آگهی') {
                                this.defaultTitle = true
                            } else if (title === 'توضیحات آگهی') {
                                this.defaultDesc = true
                            }
                        }
                    },
                    {
                        icon: 'mdi-emoticon' ? title === 'عنوان آگهی' ? 'fa fa-check' : '' : 'mdi-emoticon',
                        click: () => {
                            if (this.titleValue.length > 0 && (this.suggestTexts.titles === null)) {
                                this.authenticate();
                            } else {
                                this.getText = true;
                                this.getCookie('timer');
                            }
                        }
                    },

                ],
                type: type,
            };
        },
        generateQueryString(key, value) {
            this.queryString.delete(key);
            this.queryString.append(key, value);
        },
        reload(isAutoReload, value, name, type) {
            switch (type) {
                case "boolean":
                    const bol = Boolean(value);
                    if (bol)
                        this.parameters[name] = bol;
                    break;
                case "number":
                    this.parameters[name] = Number(value);
                    break;
                default:
                    this.parameters[name] = value;
                    break;
            }
            this.generateQueryString(name, value)
            if (isAutoReload === true) {
                $.ajax(
                    {
                        url: `${url}/divar/categories/${this.current}/dependency?`,
                        method: 'POST',
                        dataType: 'json',
                        data: JSON.stringify(this.parameters),
                        fn: this.reload,
                        params: [isAutoReload, value, name, type],
                        headers: {
                            'Authorization': Token,
                            'Content-Type': 'application/json',
                            "ACCEPT": "application/json",
                        },
                        success: (data) => {
                            const response = this.multiAdsCat === true ? data.data.filter(x => !this.multiFiltered.includes(x.name)) : data.data.filter(x => !this.singleFiltered[x.name])
                            Bus.$emit('reload', response);
                        }
                    }
                );
            }
        },
        editForm() {
            this.queryString.forEach((value, key) => {
                this.queryString.delete(key);
            });

            this.editField.forEach((key) => {
                if (typeof this.editField[key] != 'object')
                    this.queryString.set(key, this.editField[key]);
            });

            $.ajax(
                {
                    url: `${url}/user/divar/dependency/${this.current}?` + this.queryString.toString(),
                    type: 'POST',
                    dataType: 'json',
                    fn: this.editForm,
                    headers: {
                        'Authorization': Token,
                        "ACCEPT": "application/json",
                    },
                    success: (data) => {
                        this.editField.forEach((key) => {
                            let item = this.properties.find((x) => x.name === key);

                            if (typeof this.editField[key] != 'object' && item) {
                                let value = this.editField[key];
                                this.properties.find((x) => x.name === key)["value"] = value;
                            }
                        });
                    }
                }
            );
        },
        allowOnlyNumbers(value, name, type) {
            if (type === 'number') {
                let allowedKeys = [8, 46, 38, 40, 37, 39];
                const keypressed = value.which || value.keyCode;
                if (/[^0-9\s]+/.test(value.key)) {
                    if (allowedKeys.every(e => e !== keypressed)) {
                        value.preventDefault();
                    }
                } else return true
            }
        },
        isRequire(requirement) {
            if (requirement === true) {
                return true;
            } else
                return false;
        },
    },
    watch: {
        extra() {
            this.properties = [];
            this.fields.forEach((item) => {
                if (item.name != 'other_attributes_section' && item.name !== 'other_options_section') {
                    this.properties.push(this.getProperty(item));
                }
            });
            Bus.$emit('properties', this.properties)
        },
        parameters: {
            handler: function () {
                Bus.$emit('parameters', this.parameters);
            },
            deep: true
        },
    },
    computed: {
        fieldCashed() {
            return this.fields;
        },
        icon() {
            return this.icons[this.iconIndex]
        },
    },
    mounted() {
        if (this.editField.length > 0) {
            Bus.$on('getCurrent', (val) => {
                this.current = val;
            })
            this.editForm();
        }
        this.extra = this.fields
    }
}
</script>

<style scoped>

</style>